import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getCustomerName } from "./fulfillment-group-csv-utils";

export const CustomerNameCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Customer",
    cell: (row) => {
      return getCustomerName(row);
    },
  };
